<template>
  <!-- REQUEUE VAULT TRANSACTION DIALOG -->
  <v-dialog
    v-model="isOpen"
    persistent
    :max-width="600"
  >
    <v-card v-if="transaction">
      <v-card-title class="headline blue darken-1 white--text">
        Confirm requeue
        <v-chip
          small
          outline
          color="white"
        >
          {{ transaction.extIdentifier }}
        </v-chip>
      </v-card-title>

      <v-card-text>
        Are you sure you want to requeue the transaction?
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="formData.idempotentRequestId"
          label="Tangany Idempotency key"
          :messages="idempotentRequestIdMessages"
          :error="$v.formData.idempotentRequestId.$invalid"
          @input="$v.formData.idempotentRequestId.$touch()"
          @blur="$v.formData.idempotentRequestId.$touch()"
        />
      </v-card-text>
      <v-alert
        v-if="errorOnRequeue"
        :value="true"
        type="error"
        class="my-3"
      >
        {{ errorOnRequeue }}
      </v-alert>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          flat="flat"
          :disabled="loading || $v.$invalid"
          :loading="loading"
          @click="handleRequeueTransaction()"
        >
          <v-icon>restart_alt</v-icon>Requeue transaction
        </v-btn>

        <v-btn
          flat
          @click="onCloseDialog()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import getUuidByString from 'uuid-by-string';

export default {
  name: 'RequeueTransactionsDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    transaction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        idempotentRequestId: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'errorOnRequeue',
    ]),
    idempotentRequestIdMessages() {
      const messages = [];
      if (this.$v.formData.idempotentRequestId.$invalid) {
        messages.push('Required field!');
      }
      messages.push('Tangany Idempotency key is only purged after 30days. Use this field to generate a new idempotentRequestId');

      return messages;
    },
  },
  watch: {
    isOpen: {
      immediate: false,
      handler(isOpen) {
        if (isOpen) {
          this.formData.idempotentRequestId = getUuidByString(`${this.transaction.extIdentifier}_${new Date().getTime()}`);
        }
      },
    },
  },
  mounted() {

  },
  validations() {
    return {
      formData: {
        idempotentRequestId: { required },
      },
    };
  },
  methods: {
    async handleRequeueTransaction() {
      try {
        await this.requeueVaultTransactions([
          {
            extIdentifier: this.transaction.extIdentifier,
            idempotentRequestId: this.formData.idempotentRequestId,
          },
        ]);
        this.isRequeueConfirmDialog = false;
        this.onCreateTransaction();
        this.onCloseDialog();
      } catch (error) {
        console.error(error);
      }
    },
    ...mapActions([
      'requeueVaultTransactions',
    ]),
    onCloseDialog() {
      this.formData.idempotentRequestId = '';
      this.$emit('onCloseDialog');
    },
    onCreateTransaction() {
      this.$emit('onCreateTransaction');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/vault/dialog/RequeueTransactionDialog.vue